import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../common/headers';
import useGeneralStore from '../../store/general';
import { TextPage } from '../TextPage/TextPage';
import './Limit.scss'

const Limit = ({
    activeItems,
    activeSubItems
}) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const [dataLimit, setDataLimit] = useState({})

    const fetchClientStrategies = () => {

        let url = `https://apps0.ecomru.ru:4453/api/v1/tariff/services/limit/${activeItems?.id || activeSubItems?.id}`;
        if (activeItems?.id === 21) {
            url = 'https://file.ecomru.ru:4453/api/v1/file/info/space_limit'
        }

        fetch(url, { method: 'GET', headers, })
            .then((res) => {
                if (res.ok) {
                    return res?.json();
                } else {
                    throw new Error(JSON.stringify(res.json()));
                }
            })
            .then((json) => {
                setDataLimit(json);
            })
            .catch((err) => console.error(err))
    };

    useEffect(() => {
        if (activeItems?.id || activeSubItems?.id) {
            fetchClientStrategies()
        }
    }, [activeItems?.id, activeSubItems?.id])

    return (
        activeItems?.id || activeSubItems?.id) ?
        <div className='limit-info'>
            <TextPage
                text={(dataLimit?.limit === -1) ?
                    <span style={{
                        color: 'rgba(24, 144, 255, 1)',
                        fontWeight: 600
                    }}>Безлимит</span>
                    :
                    <>Всего использовано: <span style={{
                        color: 'rgba(24, 144, 255, 1)',
                        fontWeight: 600
                    }}>{dataLimit?.used || 0}</span> из <span style={{
                        color: 'rgba(24, 144, 255, 1)',
                        fontWeight: 600
                    }}>{dataLimit?.limit || 0}</span> {dataLimit?.unit}</>
                }
            />
        </div>
        :
        null
}

export { Limit }